import { z } from "zod";

export const userAuthSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Password must be at least 8 characters")
});

export const userRegisterSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z.string(),
  mobilePhone: z.string().optional(),
  planId: z.number().optional().default(1),
  invitationToken: z.string().optional(),
  agreeToTerms: z.boolean().refine((val) => val === true, {
    message: "You must agree to the Terms of Use and Privacy Policy"
  })
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
});

export const userProfileSchema = z.object({});

export type UserAuthSchema = z.infer<typeof userAuthSchema>
export type UserRegisterSchema = z.infer<typeof userRegisterSchema>

export interface AuthError extends Error {
  statusCode?: number;
}